import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

// Widget Cloudflare Turnstile. Se la site key non è configurata, non renderizza nulla
// (il backend salta la verifica finché TURNSTILE_SECRET_KEY non è impostata).
export function Turnstile({ onToken }) {
  const ref = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return;
    let cancelled = false;
    let interval = null;

    const render = () => {
      if (cancelled || !window.turnstile || !ref.current || widgetId.current) return;
      widgetId.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        callback: (t) => onToken(t),
        "expired-callback": () => onToken(""),
        "error-callback": () => onToken(""),
      });
    };

    if (window.turnstile) render();
    else interval = setInterval(() => { if (window.turnstile) { clearInterval(interval); render(); } }, 300);

    return () => { cancelled = true; if (interval) clearInterval(interval); };
  }, [onToken]);

  if (!SITE_KEY) return null;
  return <div ref={ref} className="cf-turnstile" data-testid="turnstile-widget" />;
}
